import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-film-fill text-lg" aria-hidden="true" />
            </span>
            <strong className="text-lg font-black tracking-tight text-background-50">韩国三级电影</strong>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
            韩国三级电影是一个专注韩国 R 级影视作品的资料整理站，提供分类浏览、剧情简介、演职员信息与筛选查找功能，帮助影迷高效找到感兴趣的作品。
          </p>
          <p className="mt-4 text-xs leading-relaxed text-background-300">
            本站仅提供影视资料展示，不提供在线播放与下载服务；站内片名、人物与评分为演示数据。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-bold text-background-50">
            <Link to="/" className="hover:text-accent-300">
              内容分类
            </Link>
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm text-background-200">
            {categories.slice(0, 5).map((cat) => (
              <li key={cat.id}>
                <Link to={`/category/${cat.id}`} className="transition-colors duration-200 hover:text-accent-300">
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-background-50">
            <Link to="/about" className="hover:text-accent-300">
              网站导航
            </Link>
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm text-background-200">
            <li>
              <Link to="/" className="transition-colors duration-200 hover:text-accent-300">
                首页
              </Link>
            </li>
            <li>
              <Link to="/search" className="transition-colors duration-200 hover:text-accent-300">
                搜索影片
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition-colors duration-200 hover:text-accent-300">
                关于我们
              </Link>
            </li>
            <li>
              <a
                href="mailto:contact@kfilm-demo.example"
                className="transition-colors duration-200 hover:text-accent-300"
              >
                联系邮箱
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-300 sm:flex-row md:px-6">
          <p>© 2026 韩国三级电影 · 版权所有 · 演示站点</p>
          <p>内容仅供资料参考，请勿用于商业用途</p>
        </div>
      </div>
    </footer>
  );
}